// extracted by mini-css-extract-plugin
export default {"icon":"ZMfPX1UzkKL5Ra2ZsZHpqw==","wrapper":"_4yCG0NxPy-lCIq69LN-gmA=="};